$(function () {
    let section = $('#seccionClientes')
    if (section.get(0) == null) {
        return
    }
    let vueApp = new Vue({
        el: section.get(0),
        data: {
            loader: false,
            filtros: { page: 1, buscar: null },
            clientes: [],
            modalTitulo: 'Nuevo cliente',
            cliente: {}
        },
        mounted() {
            this.getClientes()
        },
        methods: {
            getClientes(pagina = null) {
                if (this.loader) {
                    return
                }
                if (pagina != null) {
                    this.filtros.page = pagina
                }
                this.loader = true
                axios
                    .get('/admin/clientes/json', {
                        params: this.filtros,
                    })
                    .then((response) => {
                        vueApp.loader = false
                        if (response.data.error) {
                            swal({
                                icon: "info",
                                title: response.data.error,
                                button: {
                                    text: "Aceptar",
                                    closeModal: true,
                                },
                            })
                            return
                        }
                        vueApp.clientes = response.data.clientes.data;
                        vueApp.filtros.total = response.data.clientes.total;
                        vueApp.filtros.per_page = response.data.clientes.per_page;
                        vueApp.filtros.from = response.data.clientes.from;
                        vueApp.filtros.to = response.data.clientes.to;
                    })
                    .catch((error) => {
                        vueApp.loader = false
                        swal({
                            icon: "info",
                            title: "Ocurrió un error inesperado",
                            button: {
                                text: "Aceptar",
                                closeModal: true,
                            },
                        })
                    })
            },
            eliminar(id) {
                swal({
                    title: '¿Eliminar registro?',
                    icon: 'warning',
                    buttons: { cancel: 'Cancelar', ok: 'Aceptar', },
                    dangerMode: true,
                }).then((ok) => {
                    if (ok) {
                        axios
                            .delete('/admin/clientes/' + id)
                            .then(function (response) {
                                if (response.data.error) {
                                    swal({
                                        icon: "info",
                                        title: response.data.error,
                                        button: {
                                            text: "Aceptar",
                                            closeModal: true,
                                        },
                                    })
                                    return
                                }
                                vueApp.getClientes(1)
                            })
                            .catch((error) => {
                                swal({
                                    icon: "info",
                                    title: "Ocurrió un error inesperado",
                                    button: {
                                        text: "Aceptar",
                                        closeModal: true,
                                    },
                                })
                            })
                    }
                })
            },
            agregar() {
                $('#formCliente')[0].reset()
                this.cliente = Object.assign({}, {})
                this.modalTitulo = 'Nuevo cliente'
                $('#modalCliente').modal('show')
                this.validar()
            },
            editar(cliente) {
                this.cliente = Object.assign({}, cliente)
                this.modalTitulo = 'Editar cliente'
                $('#modalCliente').modal('show')
                this.validar()
            },
            validar() {
                $('#formCliente').validarForm((form) => {
                    vueApp.guardar(form)
                })
            },
            guardar(form) {
                $('#btnGuardar').loader('show')
                let formData = new FormData(form)
                axios
                    .post('/admin/clientes/guardar', formData)
                    .then((respuesta) => {
                        $('#btnGuardar').loader('hide')
                        if (respuesta.data.error) {
                            swal({
                                icon: "info",
                                title: respuesta.data.error,
                                button: {
                                    text: "Aceptar",
                                    closeModal: true,
                                },
                            })
                            return
                        }
                        $('#modalCliente').modal('hide')
                        vueApp.getClientes(1)
                    })
                    .catch((error) => {
                        console.log(error)
                        $('#btnGuardar').loader('hide')
                        swal({
                            icon: "info",
                            title: "Ocurrió un error inesperado",
                            button: {
                                text: "Aceptar",
                                closeModal: true,
                            },
                        })
                    })
            },
            eliminarTarjetas(cliente){
                swal({
                    title: '¿Eliminar tarjetas de '+cliente.nombre+'?',
                    icon: 'warning',
                    buttons: { cancel: 'Cancelar', ok: 'Aceptar', },
                    dangerMode: true,
                }).then((ok) => {
                    if (ok) {
                        axios
                            .post('/admin/clientes/' + id + '/eliminar-tarjeta')
                            .then(function (response) {
                                if (response.data.error) {
                                    swal({
                                        icon: "info",
                                        title: response.data.error,
                                        button: {
                                            text: "Aceptar",
                                            closeModal: true,
                                        },
                                    })
                                    return
                                }
                                vueApp.getClientes(1)
                                swal({
                                    icon: "success",
                                    title: "Pago recurrente cancelado",
                                    button: {
                                        text: "Aceptar",
                                        closeModal: true,
                                    },
                                })
                            })
                            .catch((error) => {
                                swal({
                                    icon: "info",
                                    title: "Ocurrió un error inesperado",
                                    button: {
                                        text: "Aceptar",
                                        closeModal: true,
                                    },
                                })
                            })
                    }
                })
            }
        },
    })
})
